import * as R from 'ramda';
import { fromJS } from 'immutable';
import * as actions from '../actions/codefile';
import { fetchingState } from '@constants';

const initialState = fromJS({
  config: {
    state: null,
    types: [],
    data: [],
    years: [],
  },
  detail: {
    state: null,
    data: [],
    sortModel: [],
    filterModel: {},
    pagination: {
      count: 0,
      page: 1,
    },
  },
  summary: {
    state: null,
    data: [],
    sortModel: [],
    filterModel: {},
    pagination: {
      count: 0,
      page: 1,
    },
  },
  generalPagination: {
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 200, 1000],
  },
});

const normalizeCodefileType = codefileConfig => [
  ...new Set(codefileConfig.map(x => x.codeFileType)),
];

const codefileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_CODEFILE_CONFIG_SUCCESS: {
      return state
        .setIn(['config', 'state'], fetchingState.LOADED)
        .setIn(
          ['config', 'types'],
          fromJS(
            normalizeCodefileType(R.pathOr([], ['data', 'results'])(action)),
          ),
        )
        .setIn(
          ['config', 'years'],
          fromJS(R.pathOr([], ['data', 'years'])(action)),
        )
        .setIn(
          ['config', 'data'],
          fromJS(R.pathOr([], ['data', 'results'])(action)),
        );
    }
    case actions.FETCH_CODEFILE_CONFIG_START: {
      return state.setIn(['config', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CODEFILE_CONFIG_ERROR: {
      return state.setIn(['config', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_DETAIL_CODEFILES_SUCCESS: {
      return state
        .setIn(['detail', 'state'], fetchingState.LOADED)
        .setIn(
          ['detail', 'data'],
          fromJS(R.pathOr([], ['data', 'results'])(action)),
        )
        .setIn(
          ['detail', 'pagination', 'count'],
          R.pathOr(0, ['data', 'total', '0', 'codeCount'])(action),
        );
    }
    case actions.FETCH_DETAIL_CODEFILES_START: {
      return state.setIn(['detail', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_DETAIL_CODEFILES_ERROR: {
      return state.setIn(['detail', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_SUMMARY_CODEFILES_SUCCESS: {
      return state
        .setIn(['summary', 'state'], fetchingState.LOADED)
        .setIn(
          ['summary', 'data'],
          fromJS(R.pathOr([], ['data', 'results'])(action)),
        );
    }
    case actions.FETCH_SUMMARY_CODEFILES_START: {
      return state.setIn(['summary', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SUMMARY_CODEFILES_ERROR: {
      return state.setIn(['summary', 'state'], fetchingState.ERROR);
    }

    case actions.INSERT_CODEFILE_SUCCESS: {
      const firstDetailItem = R.head(state.getIn(['detail', 'data']).toJS());

      // Adding new codefile item to details data array, if user just searched for this kind of codefile
      if (firstDetailItem) {
        if (
          firstDetailItem.codeFileType ===
            R.path(['data', 'results', '0', 'codeFileType'])(action) &&
          firstDetailItem.codeFileName ===
            R.path(['data', 'results', '0', 'codeFileName'])(action)
        ) {
          return state.setIn(
            ['detail', 'data'],
            fromJS([
              ...state.getIn(['detail', 'data']).toJS(),
              action.data.results[0],
            ]),
          );
        }
      }
      return state;
    }

    case actions.UPDATE_CODEFILE_SUCCESS: {
      return state.setIn(
        ['detail', 'data'],
        fromJS(
          state
            .getIn(['detail', 'data'])
            .toJS()
            .map(x => {
              const newCodefile = R.pathOr({}, ['data', 'results', '0'])(
                action,
              );
              return x.codeName === newCodefile.codeName ? newCodefile : x;
            }),
        ),
      );
    }

    case actions.DELETE_CODEFILE_SUCCESS: {
      return state.setIn(
        ['detail', 'data'],
        fromJS(
          state
            .getIn(['detail', 'data'])
            .toJS()
            .filter(x => x.codeName !== action.payload.codeName),
        ),
      );
    }
    case actions.CHANGE_DETAIL_PAGE: {
      return state.setIn(
        ['detail', 'pagination', 'page'],
        fromJS(action.payload),
      );
    }
    case actions.CHANGE_SUMMARY_PAGE: {
      return state.setIn(
        ['summary', 'pagination', 'page'],
        fromJS(action.payload),
      );
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(
        ['generalPagination', 'rowsPerPage'],
        fromJS(action.payload),
      );
    }
    case actions.CHANGE_DETAIL_SORT_MODEL: {
      return state.setIn(['detail', 'sortModel'], fromJS(action.payload));
    }
    case actions.CHANGE_SUMMARY_SORT_MODEL: {
      return state.setIn(['summary', 'sortModel'], fromJS(action.payload));
    }
    case actions.CHANGE_DETAIL_FILTER_MODEL: {
      return state.setIn(['detail', 'filterModel'], fromJS(action.payload));
    }
    case actions.CHANGE_SUMMARY_FILTER_MODEL: {
      return state.setIn(['summary', 'filterModel'], fromJS(action.payload));
    }

    default: {
      return state;
    }
  }
};

export default codefileReducer;
